import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import type { Instruction } from "@/graphql/codegen/graphql"

interface ProductStorageInstructionsPanelProps {
  instructions: Instruction[]
}

const ProductStorageInstructionsPanel: FC<ProductStorageInstructionsPanelProps> = ({ instructions }) => {
  return (
    <Box
      className='flex flex-col gap-y-6 rounded-md border border-gray-400 p-6'
      data-testid='product-storage-instructions'
    >
      <Typography variant='subtitle1' component='h2' className='text-ml'>
        Special Instructions
      </Typography>
      <Typography variant='body2' component='ul'>
        {instructions.map(({ instructionId, description }) => (
          <li data-test='instruction' key={instructionId}>
            {description}
          </li>
        ))}
      </Typography>
    </Box>
  )
}

export default ProductStorageInstructionsPanel
